import styled from 'styled-components'
// import { theme } from '../../../styles/theme'

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`

export const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  position: relative;

  & p {
    position: absolute;
    bottom: -30px;
    min-width: 200px;
    text-align: center;
  }
`

export const Check = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
`

export const Separator = styled.div`
  height: 2px;
  width: 160px;
  background: #9E9E9E;
`
